module.exports = require("./lv.d.ts");